import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import IconBase from '../IconBase';
import { jsx as _jsx } from "react/jsx-runtime";

var Twitter = function Twitter(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(IconBase, _objectSpread(_objectSpread({
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M22 5.89418C21.2642 6.21575 20.4733 6.43232 19.6433 6.52994C20.4908 6.03035 21.1417 5.23872 21.4475 4.29532C20.655 4.758 19.7767 5.09434 18.8417 5.27564C18.0942 4.49057 17.0267 4 15.8467 4C13.1975 4 11.2508 6.43314 11.8492 8.95898C8.44 8.79081 5.41667 7.18294 3.3925 4.73913C2.3175 6.55455 2.835 8.92945 4.66167 10.1321C3.99 10.1107 3.35667 9.92945 2.80417 9.62674C2.75917 11.4979 4.12167 13.2486 6.095 13.6382C5.5175 13.7925 4.885 13.8285 4.24167 13.7071C4.76333 15.3117 6.27833 16.4791 8.075 16.5119C6.35 17.8433 4.17667 18.4381 2 18.1854C3.81583 19.3314 5.97333 20 8.29 20C15.9083 20 20.2125 13.6661 19.9525 7.98523C20.7542 7.41509 21.45 6.70386 22 5.89418Z",
      fill: color
    })
  }));
};

export default Twitter;